
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12645',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12645",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9761",
  "foundations-components": "static-1.8120",
  "foundations-components-legacy": "static-1.1145",
  "foundations-theming": "static-1.4529",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8117",
  "hub-http-shared-msw-handlers": "static-1.10199",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11572",
  "I18n": "static-7.1634",
  "jasmine-runner": "static-1.6559",
  "marketplace-storefront-base": "static-1.12708",
  "quartz": "static-1.7151",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16780",
  "reactive-variable-buffer-atom": "static-1.2957",
  "reporting-testing-lib": "static-1.9866",
  "settings-ui-lib": "static-1.12619",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7313",
  "ui-addon-i18n": "static-1.11248",
  "ui-addon-react-router-dom": "static-1.9637",
  "unified-auth": "static-1.607",
  "unified-auth-core-lib": "static-1.889",
  "usage-tracker": "static-1.7446",
  "usage-tracker-core": "static-1.7296",
  "customer-data-property-utils": "static-1.8194",
  "hub-http": "static-1.6320",
  "integrations-lib": "static-1.16469",
  "marketplace-ui-common": "static-1.20096",
  "property-management-iframe": "static-1.13495",
  "quartz-config": "static-1.929",
  "quartz-core": "static-1.6370",
  "quartz-routing": "static-1.581",
  "quick-fetch": "static-1.3989",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4754",
  "ts-schema": "static-1.4152",
  "ui-universal-auth": "static-1.9093",
  "UIComponents": "static-3.8518",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3470",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3428",
  "quartz-webpack": "static-1.3375",
  "bend-plugin-quartz-routing": "static-1.229",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4389",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4968",
  "foundations-theming-specialty": "static-1.2245",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9521",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5414",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2168",
  "ui-fonts": "static-1.834",
  "ui-images": "static-2.1176",
  "bend-plugin-foundations-theming": "static-1.3012",
  "foundations-theming-base": "static-1.3514",
  "stylex": "static-1.34",
  "HeadJS": "static-2.766",
  "hs-test-utils-bend-plugin": "static-1.3228",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4425",
  "ai-components-ui-library": "static-1.9195",
  "ai-rendering-library": "static-1.10509",
  "chirp-fetch": "static-1.1986",
  "connections-embed-lib": "static-1.1164",
  "copilot-toolkit": "static-1.11381",
  "feedback-loader": "static-1.29474",
  "laboratory-lib": "static-3.7253",
  "marketplace-embed": "static-1.22395",
  "marketplace-ui-details": "static-1.9991",
  "marketplace-ui-reviews": "static-1.20051",
  "marketplace-ui-tracking": "static-1.14266",
  "sanitize-text": "static-1.8243",
  "ui-addon-video-player": "static-1.8802",
  "usage-tracker-multi": "static-1.5860",
  "usage-tracker-session-replay": "static-1.5132",
  "wootric-nps": "static-1.7055",
  "quartz-head": "static-1.816",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4751",
  "immer": "static-1.33",
  "immerable": "static-1.4252",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67933",
  "cssUtils": "static-1.819",
  "flux-actions": "static-1.343",
  "HubStyle": "static-2.11879",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10306",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10460",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7436",
  "icons": "static-2.651",
  "marketplace-ui-apps-core": "static-1.18628",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4611",
  "foundations-components-test-utils": "static-1.5603",
  "quartz-i18n": "static-1.826",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.306",
  "google-sheets-integration-lib": "static-1.520",
  "microsoft-drive-integration-lib": "static-1.656",
  "slack-ui-library": "static-1.10492",
  "fsm": "static-1.3828",
  "customer-data-objects": "static-1.7777",
  "property-translator": "static-1.5495",
  "hs-locale-management": "static-1.153",
  "frontend-preferences-client": "static-1.8024",
  "hs-promise-utils": "static-1.5689",
  "hubspot-apollo-client": "static-1.4976",
  "integrations-error-boundary-lib": "static-1.13884",
  "integrations-tracking-lib": "static-1.5704",
  "native-integrations-shared-strings": "static-1.7882",
  "reselect": "static-2.16",
  "sanitize": "static-1.4575",
  "superstore": "static-1.4859",
  "ui-shepherd-react": "static-3.10321",
  "ai-settings-ui-library": "static-1.8039",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4723",
  "immutable-less": "static-1.4752",
  "marketplace-ui-client-types": "static-1.17503",
  "nav-meta": "static-1.29891",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18132",
  "inbound-db-properties-service-client": "static-1.3917",
  "property-management-common": "static-1.5783",
  "ui-addon-iframeable": "static-1.9163",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.26",
  "quartz-auth": "static-1.826",
  "quartz-test": "static-1.826",
  "quartz-tracking": "static-1.530",
  "trellis-components": "static-1.2187",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.164",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21755",
  "ContentUtils": "static-1.68636",
  "customer-data-objects-ui-components": "static-1.13128",
  "sassPrefix": "static-1.158",
  "breeze-engine-core": "static-1.310",
  "breeze-onboarding-components": "static-1.201",
  "avatar-components": "static-1.2595",
  "customer-data-filters-ui": "static-1.40118",
  "customer-data-reference-ui-components": "static-1.13269",
  "embedded-academy-lib": "static-1.14639",
  "ExportDialog": "static-6.10479",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41548",
  "reporting-snowflake": "static-1.56551",
  "reporting-ui-components": "static-2.65204",
  "reporting-visualizations": "static-1.60009",
  "ui-addon-teams": "static-1.21679",
  "integrations-reconnect-lib": "static-1.137",
  "magpie-lib": "static-1.5615",
  "navigation-components": "static-1.18254",
  "breeze-engine-lib": "static-1.1032",
  "magpie-types": "static-1.5075",
  "simple-logging-lib": "static-1.3149",
  "ai-studio-lib": "static-1.11894",
  "app-governance-lib": "static-1.1858",
  "developer-experience-shared-components": "static-1.10613",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8105",
  "ui-product-approvals": "static-1.28548",
  "ui-tool-access": "static-1.10246",
  "usage-based-billing-components-lib": "static-1.9355",
  "usage-tracker-anonymous": "static-1.5863",
  "usage-tracker-public": "static-1.7257",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3658",
  "persist-promise": "static-1.3797",
  "reference-resolvers": "static-1.8272",
  "ui-extensibility-client-types": "static-1.4023",
  "hubspot-apollo-cache": "static-1.435",
  "universal-page-editor-lib": "static-1.3116",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3050",
  "atom": "static-1.5173",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6066",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1640",
  "crm-component-utils": "static-1.39330",
  "crm-properties-common-lib": "static-1.5987",
  "customer-data-properties": "static-1.51907",
  "framework-data-schema-resolvers": "static-1.6988",
  "property-value-citations": "static-1.2521",
  "reference-resolvers-lite": "static-1.8196",
  "ui-business-units-lib": "static-1.9160",
  "navigation-messaging": "static-1.7581",
  "hubspotter-http-shared-msw-handlers": "static-1.10197",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1039",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4912",
  "content-icons-ui": "static-1.2253",
  "customer-data-ui-utilities": "static-1.9924",
  "conversations-skeleton-state": "static-1.7347",
  "crm-message-bus": "static-1.43230",
  "customer-data-filters-ui-msw-helpers": "static-1.22553",
  "events-data-lib": "static-1.329",
  "FormUrlGenerator": "static-2.4820",
  "framework-builder-read-service-client": "static-1.4076",
  "framework-data-schema-quick-fetch": "static-1.6893",
  "multi-account-reference-resolvers": "static-1.1081",
  "onboarding-tours": "static-1.16780",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13954",
  "academy-common-lib": "static-1.14099",
  "content-assistance-lib": "static-1.7905",
  "dashboard-lib": "static-1.81903",
  "file-manager-components": "static-1.23874",
  "getting-started-shared-tasks": "static-1.18679",
  "hubspot-prosemirror": "static-1.18496",
  "hubspot-prosemirror-plugins": "static-1.18488",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19996",
  "share-with-third-party-component-lib": "static-1.8802",
  "ui-addon-draggable": "static-3.4859",
  "ui-asset-management-lib": "static-1.11159",
  "user-context": "static-1.5209",
  "growth-payments-core": "static-1.25661",
  "reporting-plugins": "static-1.10486",
  "reporting-reports": "static-1.67611",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.824",
  "nest": "static-1.331",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10726",
  "framework-listing-lib": "static-2.28963",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30944",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4350",
  "react-dnd-compat": "static-1.4713",
  "ui-product-approvals-common": "static-1.443",
  "onboarding-scopes": "static-1.6560",
  "onboarding-tours-client": "static-1.4994",
  "platform-infra-nav-components": "static-1.7744",
  "subscription-experience-data-types": "static-1.15050",
  "crm-record-cards-service-types": "static-1.3661",
  "location-customization-utils-lib": "static-1.9538",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6069",
  "signup-constants": "static-1.19063",
  "signup-ui-url-generator": "static-2.8155",
  "card-properties-lib": "static-1.44484",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6437",
  "crm-cards-sdk": "static-1.43867",
  "customer-data-properties-shared-msw-handlers": "static-1.9526",
  "customer-data-tracking": "static-1.6988",
  "hs-resources": "static-1.273",
  "pulse": "static-1.694",
  "calling-global-api": "static-1.64842",
  "calling-internal-common": "static-1.31409",
  "calling-lifecycle-internal": "static-1.66224",
  "calling-lifecycle-messages": "static-1.58518",
  "commerce-products-lib": "static-1.9898",
  "conditional-properties-service-client": "static-1.3868",
  "crm-links": "static-1.6404",
  "crm-pipelines-api-client-types": "static-1.4210",
  "external-options-client-types": "static-1.4201",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4291",
  "meetings-icalendar-utils-lib": "static-1.733",
  "multi-currency-client-types": "static-1.3762",
  "object-builder-ui-client": "static-1.49078",
  "pipeline-validation-client-types": "static-1.4038",
  "smart-property-lib": "static-1.7684",
  "tiered-pricing": "static-1.1444",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11088",
  "fdsr-migration-layer": "static-1.107",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1120",
  "growth-data-modal": "static-1.5581",
  "growth-onboarding-confetti": "static-1.3164",
  "growth-onboarding-next-action-utils": "static-1.2201",
  "onboarding-tours-utils": "static-1.846",
  "ui-shepherd-tracker": "static-1.7702",
  "academy-service-client": "static-1.3781",
  "SafeStorage": "static-1.4498",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39373",
  "FileManagerLib": "static-1.39514",
  "video-embed": "static-1.36078",
  "ui-coaching-tips": "static-1.28829",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11586",
  "video-data-lib": "static-1.35244",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8558",
  "payment-link-components": "static-1.23774",
  "ui-addon-emoji-picker": "static-1.9986",
  "EmailSignatureEditor": "static-1.24585",
  "viral-links-lib": "static-1.7167",
  "data-token-picker": "static-1.16575",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.322",
  "timezone-utils": "static-2.5341",
  "seat-types-lib": "static-1.238",
  "getting-started-shared-tasks-store": "static-1.17797",
  "ui-addon-opt": "static-4.8459",
  "campaign-roi-lib": "static-1.9373",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25644",
  "framework-data-table": "static-2.12133",
  "marketing-platform-lib": "static-1.6964",
  "nudge-client-utils": "static-1.2783",
  "nudge-custom-ui-functions": "static-1.1199",
  "switchboard-lib": "static-1.321",
  "app-users-service-client": "static-1.5707",
  "app-users-service-types": "static-1.5115",
  "mini-checkout-client": "static-1.27049",
  "onboarding-utils": "static-1.5458",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28814",
  "edison-service-client-types": "static-1.487",
  "crm_data": "static-4.92262",
  "customer-data-sidebar": "static-2.46279",
  "enrichment-properties-lib": "static-1.16802",
  "ui-addon-draggable-compat": "static-2.4357",
  "universal-record-utils-lib": "static-1.1186",
  "commerce-billing-lib": "static-1.19382",
  "commerce-shared-components-lib": "static-1.18759",
  "commerce-tools-ui-lib": "static-1.10629",
  "crm-fe-perf": "static-1.23003",
  "event-emitter": "static-1.1048",
  "bend-plugin-pulse": "static-1.197",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31416",
  "shared-worker-versioning": "static-1.11134",
  "calling-usage-tracker": "static-1.6642",
  "voice-sms-access-library": "static-1.1379",
  "commerce-permissions": "static-1.877",
  "products-iframe-lib": "static-1.8199",
  "products-ui-components-shared-msw-handlers": "static-1.10581",
  "data-agent-kit": "static-1.351",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10282",
  "policy-lib": "static-1.6878",
  "react-tinymce": "static-1.55498",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10345",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54624",
  "tinymce-plugins": "static-1.57738",
  "tinymce-themes": "static-1.56594",
  "onboarding-data-sync-lib": "static-1.2125",
  "growth-onboarding-next-action-components": "static-1.2229",
  "user-context-client": "static-1.4681",
  "audio-components": "static-1.6063",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37025",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4635",
  "video-components": "static-1.13588",
  "outpost": "static-1.4269",
  "growth-onboarding-feedback-components": "static-1.6678",
  "content-media-composition-data-lib": "static-1.12610",
  "content-media-compositions": "static-2.16617",
  "media-bridge-lib": "static-1.19091",
  "commerce-tours-lib": "static-1.6277",
  "growth-onboarding-reliability": "static-1.5180",
  "sales-checkout-service-client": "static-1.3690",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21843",
  "sales-email-signature-service-client": "static-1.3947",
  "ts-utils-lib": "static-1.271",
  "crm-export-dialog": "static-1.6384",
  "crm-index-associations-lib": "static-1.6542",
  "crm-view-components": "static-1.567",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7429",
  "nudge-custom-function-registry": "static-1.2540",
  "nudge-renderer-utils": "static-1.2859",
  "whisper-core-api": "static-1.6828",
  "InboxConnectUtils": "static-4.15065",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5760",
  "settings-content-modals": "static-1.46356",
  "crm_universal": "static-1.22175",
  "customer-data-email": "static-1.18203",
  "card-payment-highlight-lib": "static-1.37445",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12537",
  "invoices-highlight-card-lib": "static-1.55033",
  "orders-highlight-card-lib": "static-1.21732",
  "products-highlight-card-lib": "static-1.18181",
  "quotes-highlight-card-lib": "static-1.72340",
  "crm-source-interpretation-lib": "static-1.5441",
  "crm-object-search-query-utilities": "static-1.9796",
  "utility-belt": "static-1.2631",
  "payments-enrollment-embed-lib": "static-1.23194",
  "stripe-embedded-components": "static-1.7677",
  "customer-data-rte": "static-1.33247",
  "cv-backend-services": "static-1.1557",
  "growth-onboarding-empty-states": "static-1.5915",
  "payments-post-enroll-local-storage-lib": "static-1.5205",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38430",
  "trials-service-types": "static-1.3979",
  "calling-orchestration-schema": "static-1.36156",
  "sales-views-client-types": "static-1.4354",
  "hub-http-contrib": "static-1.3141",
  "interframe": "static-3.4859",
  "tinymce-data": "static-1.40709",
  "ui-addon-sales-email": "static-1.5309",
  "layout-dnd-components": "static-1.12628",
  "layout-dnd-utils": "static-1.11603",
  "ui-brand-identity-lib": "static-1.15618",
  "NamespacedHubStyle": "static-2.9129",
  "meetings-connect-utils-lib": "static-1.7703",
  "social-insights-client-types": "static-1.22309",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4261",
  "checkout-sdk": "static-3.23892",
  "checkout-service-types": "static-1.3871",
  "company-details-components": "static-1.6296",
  "payment-method-components": "static-1.6973",
  "pricing-pages-ui-components": "static-1.14616",
  "quote-checkout-service-types": "static-1.3561",
  "upgrade-catalog-service-types": "static-1.3619",
  "access-control-lib": "static-1.10533",
  "EmailComponents": "static-1.55032",
  "EmailData": "static-1.53709",
  "redux-less": "static-2.9582",
  "sequences-lib": "static-1.8210",
  "ui-gdpr-components": "static-1.10449",
  "products-ui-components": "static-1.40416",
  "accounting-integrations-ui-components": "static-1.7219",
  "invoices-ui-lib": "static-1.55049",
  "commerce-products-api": "static-1.2434",
  "invoices-iframe-lib": "static-1.57107",
  "quotes-modal-lib": "static-1.103018",
  "quotes-ui-lib": "static-1.81061",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28518",
  "ContentData": "static-1.68711",
  "layout-data-lib": "static-1.9928",
  "hub-http-rxjs": "static-1.807",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4036",
  "billing-payments-client-types": "static-1.4089",
  "react-performance-metrics-lib": "static-1.654",
  "account-and-billing-fintech-outages": "static-3.18704",
  "pricing-pages-api": "static-1.14481",
  "ContentComponents": "static-2.71592",
  "marketing-contacts-lib": "static-1.10370",
  "marketing-email-service-types": "static-1.1974",
  "messaging-editing-lib": "static-1.46541",
  "messaging-usage-based-billing-components-lib": "static-1.1403",
  "automation-ui-source-apps": "static-1.19161",
  "automation-ui-types": "static-1.20079",
  "messaging-types-lib": "static-1.46278",
  "onboarding-settings-client": "static-1.4602",
  "sequences-client-types-lib": "static-1.8067",
  "commerce-tax-lib": "static-1.635",
  "price-books-api": "static-1.1184",
  "price-books-components": "static-1.1242",
  "property-description-translator": "static-1.3939",
  "ramp-editor": "static-1.378",
  "commerce-analytics-service-client": "static-1.3678",
  "totals-ui-components": "static-1.23860",
  "SalesContentIndexUI": "static-3.9383",
  "advanced-menus-core": "static-1.15283",
  "advanced-menus-lib": "static-1.12198",
  "ui-memberships-settings-lib": "static-1.34305",
  "segments-query-core": "static-1.1517",
  "automation-ui-ubb": "static-1.5995",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7437",
  "data-token-views": "static-1.16556",
  "forms-utils-lib": "static-1.12763",
  "payments-embed-points-lib": "static-1.13231",
  "simple-menus-core": "static-1.15282",
  "simple-menus-lib": "static-1.16799",
  "videoconference-integration-components": "static-1.6956",
  "marketing-contacts-client": "static-1.7612",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2626",
  "ContentEditorUI": "static-2.77374",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13927",
  "web-interactives-data": "static-1.13928",
  "messaging-shared-utils-lib": "static-1.852",
  "messaging-user-info-utils-lib": "static-1.1022",
  "email-portal-health-service-types": "static-1.1075",
  "line-items-api": "static-1.837",
  "commerce-totals-service-types": "static-1.3890",
  "FireAlarmUi": "static-1.4582",
  "sales-templates-service-types-lib": "static-1.4241",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22015",
  "automation-ui-usage-tracking": "static-1.21478",
  "data-studio-ubb": "static-1.2998",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27239",
  "collaboration-sidebar": "static-1.58116",
  "content-management-data-lib": "static-1.5563",
  "copilot-plugins": "static-1.11354",
  "cta-picker": "static-1.36655",
  "customer-agent-discovery-components-lib": "static-1.3358",
  "editor-components": "static-1.13365",
  "editor-iframe-lib": "static-1.8536",
  "error-messaging-js": "static-1.5290",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10744",
  "SharedLegalStrings": "static-1.1843",
  "smart-content-core": "static-1.42701",
  "smart-content-lib": "static-1.43354",
  "social-composer-lib": "static-1.59504",
  "structured-content-lib": "static-1.25444",
  "theme-previewer-lib": "static-1.53503",
  "tinymce-copilot": "static-1.16692",
  "xray-recommendation-lib": "static-1.8035",
  "automation-ui-routing": "static-1.21436",
  "sql-reporting-client-types": "static-1.5716",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42400",
  "campaigns-utils-lib": "static-1.3286",
  "reporting-enablement": "static-1.23258",
  "chatspot-widget-iframe": "static-1.21746",
  "collaboration-sidebar-common": "static-1.2913",
  "forms-ai-lib": "static-1.4469",
  "codemirror-dlb": "static-1.58933",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6533",
  "report-customization-components": "static-1.13423",
  "data-quality-ui-library": "static-1.13284",
  "reporting-filters": "static-1.561",
  "reporting-insights-lib": "static-1.2025"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12645",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9761",
  "foundations-components": "/foundations-components/static-1.8120",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1145",
  "foundations-theming": "/foundations-theming/static-1.4529",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8117",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10199",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11572",
  "I18n": "/I18n/static-7.1634",
  "jasmine-runner": "/jasmine-runner/static-1.6559",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12708",
  "quartz": "/quartz/static-1.7151",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16780",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2957",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9866",
  "settings-ui-lib": "/settings-ui-lib/static-1.12619",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7313",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11248",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9637",
  "unified-auth": "/unified-auth/static-1.607",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.889",
  "usage-tracker": "/usage-tracker/static-1.7446",
  "usage-tracker-core": "/usage-tracker-core/static-1.7296",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8194",
  "hub-http": "/hub-http/static-1.6320",
  "integrations-lib": "/integrations-lib/static-1.16469",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20096",
  "property-management-iframe": "/property-management-iframe/static-1.13495",
  "quartz-config": "/quartz-config/static-1.929",
  "quartz-core": "/quartz-core/static-1.6370",
  "quartz-routing": "/quartz-routing/static-1.581",
  "quick-fetch": "/quick-fetch/static-1.3989",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4754",
  "ts-schema": "/ts-schema/static-1.4152",
  "ui-universal-auth": "/ui-universal-auth/static-1.9093",
  "UIComponents": "/UIComponents/static-3.8518",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3470",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3428",
  "quartz-webpack": "/quartz-webpack/static-1.3375",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.229",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4389",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4968",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2245",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9521",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5414",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2168",
  "ui-fonts": "/ui-fonts/static-1.834",
  "ui-images": "/ui-images/static-2.1176",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3012",
  "foundations-theming-base": "/foundations-theming-base/static-1.3514",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.766",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3228",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4425",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9195",
  "ai-rendering-library": "/ai-rendering-library/static-1.10509",
  "chirp-fetch": "/chirp-fetch/static-1.1986",
  "connections-embed-lib": "/connections-embed-lib/static-1.1164",
  "copilot-toolkit": "/copilot-toolkit/static-1.11381",
  "feedback-loader": "/feedback-loader/static-1.29474",
  "laboratory-lib": "/laboratory-lib/static-3.7253",
  "marketplace-embed": "/marketplace-embed/static-1.22395",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9991",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20051",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14266",
  "sanitize-text": "/sanitize-text/static-1.8243",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8802",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5860",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5132",
  "wootric-nps": "/wootric-nps/static-1.7055",
  "quartz-head": "/quartz-head/static-1.816",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4751",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4252",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67933",
  "cssUtils": "/cssUtils/static-1.819",
  "flux-actions": "/flux-actions/static-1.343",
  "HubStyle": "/HubStyle/static-2.11879",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10306",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10460",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7436",
  "icons": "/icons/static-2.651",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18628",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4611",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5603",
  "quartz-i18n": "/quartz-i18n/static-1.826",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.306",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.520",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.656",
  "slack-ui-library": "/slack-ui-library/static-1.10492",
  "fsm": "/fsm/static-1.3828",
  "customer-data-objects": "/customer-data-objects/static-1.7777",
  "property-translator": "/property-translator/static-1.5495",
  "hs-locale-management": "/hs-locale-management/static-1.153",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8024",
  "hs-promise-utils": "/hs-promise-utils/static-1.5689",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4976",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13884",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5704",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7882",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4575",
  "superstore": "/superstore/static-1.4859",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10321",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8039",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4723",
  "immutable-less": "/immutable-less/static-1.4752",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17503",
  "nav-meta": "/nav-meta/static-1.29891",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18132",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3917",
  "property-management-common": "/property-management-common/static-1.5783",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9163",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.26",
  "quartz-auth": "/quartz-auth/static-1.826",
  "quartz-test": "/quartz-test/static-1.826",
  "quartz-tracking": "/quartz-tracking/static-1.530",
  "trellis-components": "/trellis-components/static-1.2187",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.164",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21755",
  "ContentUtils": "/ContentUtils/static-1.68636",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13128",
  "sassPrefix": "/sassPrefix/static-1.158",
  "breeze-engine-core": "/breeze-engine-core/static-1.310",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.201",
  "avatar-components": "/avatar-components/static-1.2595",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40118",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13269",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14639",
  "ExportDialog": "/ExportDialog/static-6.10479",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41548",
  "reporting-snowflake": "/reporting-snowflake/static-1.56551",
  "reporting-ui-components": "/reporting-ui-components/static-2.65204",
  "reporting-visualizations": "/reporting-visualizations/static-1.60009",
  "ui-addon-teams": "/ui-addon-teams/static-1.21679",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.137",
  "magpie-lib": "/magpie-lib/static-1.5615",
  "navigation-components": "/navigation-components/static-1.18254",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1032",
  "magpie-types": "/magpie-types/static-1.5075",
  "simple-logging-lib": "/simple-logging-lib/static-1.3149",
  "ai-studio-lib": "/ai-studio-lib/static-1.11894",
  "app-governance-lib": "/app-governance-lib/static-1.1858",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10613",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8105",
  "ui-product-approvals": "/ui-product-approvals/static-1.28548",
  "ui-tool-access": "/ui-tool-access/static-1.10246",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9355",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5863",
  "usage-tracker-public": "/usage-tracker-public/static-1.7257",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3658",
  "persist-promise": "/persist-promise/static-1.3797",
  "reference-resolvers": "/reference-resolvers/static-1.8272",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4023",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.435",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3116",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3050",
  "atom": "/atom/static-1.5173",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6066",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1640",
  "crm-component-utils": "/crm-component-utils/static-1.39330",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5987",
  "customer-data-properties": "/customer-data-properties/static-1.51907",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6988",
  "property-value-citations": "/property-value-citations/static-1.2521",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8196",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9160",
  "navigation-messaging": "/navigation-messaging/static-1.7581",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10197",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1039",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4912",
  "content-icons-ui": "/content-icons-ui/static-1.2253",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9924",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7347",
  "crm-message-bus": "/crm-message-bus/static-1.43230",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22553",
  "events-data-lib": "/events-data-lib/static-1.329",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4820",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4076",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6893",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1081",
  "onboarding-tours": "/onboarding-tours/static-1.16780",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13954",
  "academy-common-lib": "/academy-common-lib/static-1.14099",
  "content-assistance-lib": "/content-assistance-lib/static-1.7905",
  "dashboard-lib": "/dashboard-lib/static-1.81903",
  "file-manager-components": "/file-manager-components/static-1.23874",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18679",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18496",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18488",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19996",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8802",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4859",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11159",
  "user-context": "/user-context/static-1.5209",
  "growth-payments-core": "/growth-payments-core/static-1.25661",
  "reporting-plugins": "/reporting-plugins/static-1.10486",
  "reporting-reports": "/reporting-reports/static-1.67611",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.824",
  "nest": "/nest/static-1.331",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10726",
  "framework-listing-lib": "/framework-listing-lib/static-2.28963",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30944",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4350",
  "react-dnd-compat": "/react-dnd-compat/static-1.4713",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.443",
  "onboarding-scopes": "/onboarding-scopes/static-1.6560",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4994",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7744",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15050",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3661",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9538",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6069",
  "signup-constants": "/signup-constants/static-1.19063",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8155",
  "card-properties-lib": "/card-properties-lib/static-1.44484",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6437",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43867",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9526",
  "customer-data-tracking": "/customer-data-tracking/static-1.6988",
  "hs-resources": "/hs-resources/static-1.273",
  "pulse": "/pulse/static-1.694",
  "calling-global-api": "/calling-global-api/static-1.64842",
  "calling-internal-common": "/calling-internal-common/static-1.31409",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66224",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58518",
  "commerce-products-lib": "/commerce-products-lib/static-1.9898",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3868",
  "crm-links": "/crm-links/static-1.6404",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4210",
  "external-options-client-types": "/external-options-client-types/static-1.4201",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4291",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.733",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3762",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49078",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4038",
  "smart-property-lib": "/smart-property-lib/static-1.7684",
  "tiered-pricing": "/tiered-pricing/static-1.1444",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11088",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.107",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1120",
  "growth-data-modal": "/growth-data-modal/static-1.5581",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3164",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2201",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.846",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7702",
  "academy-service-client": "/academy-service-client/static-1.3781",
  "SafeStorage": "/SafeStorage/static-1.4498",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39373",
  "FileManagerLib": "/FileManagerLib/static-1.39514",
  "video-embed": "/video-embed/static-1.36078",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28829",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11586",
  "video-data-lib": "/video-data-lib/static-1.35244",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8558",
  "payment-link-components": "/payment-link-components/static-1.23774",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9986",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24585",
  "viral-links-lib": "/viral-links-lib/static-1.7167",
  "data-token-picker": "/data-token-picker/static-1.16575",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.322",
  "timezone-utils": "/timezone-utils/static-2.5341",
  "seat-types-lib": "/seat-types-lib/static-1.238",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17797",
  "ui-addon-opt": "/ui-addon-opt/static-4.8459",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9373",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25644",
  "framework-data-table": "/framework-data-table/static-2.12133",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6964",
  "nudge-client-utils": "/nudge-client-utils/static-1.2783",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1199",
  "switchboard-lib": "/switchboard-lib/static-1.321",
  "app-users-service-client": "/app-users-service-client/static-1.5707",
  "app-users-service-types": "/app-users-service-types/static-1.5115",
  "mini-checkout-client": "/mini-checkout-client/static-1.27049",
  "onboarding-utils": "/onboarding-utils/static-1.5458",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28814",
  "edison-service-client-types": "/edison-service-client-types/static-1.487",
  "crm_data": "/crm_data/static-4.92262",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46279",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16802",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4357",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1186",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19382",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18759",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10629",
  "crm-fe-perf": "/crm-fe-perf/static-1.23003",
  "event-emitter": "/event-emitter/static-1.1048",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.197",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31416",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11134",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6642",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1379",
  "commerce-permissions": "/commerce-permissions/static-1.877",
  "products-iframe-lib": "/products-iframe-lib/static-1.8199",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10581",
  "data-agent-kit": "/data-agent-kit/static-1.351",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10282",
  "policy-lib": "/policy-lib/static-1.6878",
  "react-tinymce": "/react-tinymce/static-1.55498",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10345",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54624",
  "tinymce-plugins": "/tinymce-plugins/static-1.57738",
  "tinymce-themes": "/tinymce-themes/static-1.56594",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2125",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2229",
  "user-context-client": "/user-context-client/static-1.4681",
  "audio-components": "/audio-components/static-1.6063",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37025",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4635",
  "video-components": "/video-components/static-1.13588",
  "outpost": "/outpost/static-1.4269",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6678",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12610",
  "content-media-compositions": "/content-media-compositions/static-2.16617",
  "media-bridge-lib": "/media-bridge-lib/static-1.19091",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6277",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5180",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3690",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21843",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3947",
  "ts-utils-lib": "/ts-utils-lib/static-1.271",
  "crm-export-dialog": "/crm-export-dialog/static-1.6384",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6542",
  "crm-view-components": "/crm-view-components/static-1.567",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7429",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2540",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2859",
  "whisper-core-api": "/whisper-core-api/static-1.6828",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15065",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5760",
  "settings-content-modals": "/settings-content-modals/static-1.46356",
  "crm_universal": "/crm_universal/static-1.22175",
  "customer-data-email": "/customer-data-email/static-1.18203",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37445",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12537",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55033",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21732",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18181",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72340",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5441",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9796",
  "utility-belt": "/utility-belt/static-1.2631",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23194",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7677",
  "customer-data-rte": "/customer-data-rte/static-1.33247",
  "cv-backend-services": "/cv-backend-services/static-1.1557",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5915",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5205",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38430",
  "trials-service-types": "/trials-service-types/static-1.3979",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36156",
  "sales-views-client-types": "/sales-views-client-types/static-1.4354",
  "hub-http-contrib": "/hub-http-contrib/static-1.3141",
  "interframe": "/interframe/static-3.4859",
  "tinymce-data": "/tinymce-data/static-1.40709",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5309",
  "layout-dnd-components": "/layout-dnd-components/static-1.12628",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11603",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15618",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9129",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7703",
  "social-insights-client-types": "/social-insights-client-types/static-1.22309",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4261",
  "checkout-sdk": "/checkout-sdk/static-3.23892",
  "checkout-service-types": "/checkout-service-types/static-1.3871",
  "company-details-components": "/company-details-components/static-1.6296",
  "payment-method-components": "/payment-method-components/static-1.6973",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14616",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3561",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3619",
  "access-control-lib": "/access-control-lib/static-1.10533",
  "EmailComponents": "/EmailComponents/static-1.55032",
  "EmailData": "/EmailData/static-1.53709",
  "redux-less": "/redux-less/static-2.9582",
  "sequences-lib": "/sequences-lib/static-1.8210",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10449",
  "products-ui-components": "/products-ui-components/static-1.40416",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7219",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55049",
  "commerce-products-api": "/commerce-products-api/static-1.2434",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57107",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103018",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81061",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28518",
  "ContentData": "/ContentData/static-1.68711",
  "layout-data-lib": "/layout-data-lib/static-1.9928",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.807",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4036",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4089",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.654",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18704",
  "pricing-pages-api": "/pricing-pages-api/static-1.14481",
  "ContentComponents": "/ContentComponents/static-2.71592",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10370",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1974",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46541",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1403",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19161",
  "automation-ui-types": "/automation-ui-types/static-1.20079",
  "messaging-types-lib": "/messaging-types-lib/static-1.46278",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4602",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8067",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.635",
  "price-books-api": "/price-books-api/static-1.1184",
  "price-books-components": "/price-books-components/static-1.1242",
  "property-description-translator": "/property-description-translator/static-1.3939",
  "ramp-editor": "/ramp-editor/static-1.378",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3678",
  "totals-ui-components": "/totals-ui-components/static-1.23860",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9383",
  "advanced-menus-core": "/advanced-menus-core/static-1.15283",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12198",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34305",
  "segments-query-core": "/segments-query-core/static-1.1517",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5995",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7437",
  "data-token-views": "/data-token-views/static-1.16556",
  "forms-utils-lib": "/forms-utils-lib/static-1.12763",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13231",
  "simple-menus-core": "/simple-menus-core/static-1.15282",
  "simple-menus-lib": "/simple-menus-lib/static-1.16799",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6956",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7612",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2626",
  "ContentEditorUI": "/ContentEditorUI/static-2.77374",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13927",
  "web-interactives-data": "/web-interactives-data/static-1.13928",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.852",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1022",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1075",
  "line-items-api": "/line-items-api/static-1.837",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3890",
  "FireAlarmUi": "/FireAlarmUi/static-1.4582",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4241",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22015",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21478",
  "data-studio-ubb": "/data-studio-ubb/static-1.2998",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27239",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58116",
  "content-management-data-lib": "/content-management-data-lib/static-1.5563",
  "copilot-plugins": "/copilot-plugins/static-1.11354",
  "cta-picker": "/cta-picker/static-1.36655",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3358",
  "editor-components": "/editor-components/static-1.13365",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8536",
  "error-messaging-js": "/error-messaging-js/static-1.5290",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10744",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1843",
  "smart-content-core": "/smart-content-core/static-1.42701",
  "smart-content-lib": "/smart-content-lib/static-1.43354",
  "social-composer-lib": "/social-composer-lib/static-1.59504",
  "structured-content-lib": "/structured-content-lib/static-1.25444",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53503",
  "tinymce-copilot": "/tinymce-copilot/static-1.16692",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8035",
  "automation-ui-routing": "/automation-ui-routing/static-1.21436",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5716",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42400",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3286",
  "reporting-enablement": "/reporting-enablement/static-1.23258",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21746",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2913",
  "forms-ai-lib": "/forms-ai-lib/static-1.4469",
  "codemirror-dlb": "/codemirror-dlb/static-1.58933",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6533",
  "report-customization-components": "/report-customization-components/static-1.13423",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13284",
  "reporting-filters": "/reporting-filters/static-1.561",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2025"
}
};
